const pages = [
    {
        url: "/privacy-policy",
        title: "Our Privacy Policy",
        subtitle: "Last updated 8th August 2018",
        content: require("./pageMarkdown/privacy-policy.md")
    },
    {
        url: "/terms-conditions",
        title: "Terms & Conditions",
        subtitle: "Last updated 8th August 2018",
        content: require("./pageMarkdown/terms-conditions.md")
    }
];

export default pages;



// WEBPACK FOOTER //
// ./src/pages.js